import { cn } from '../../lib/cn';
import type { PipelineRunRow } from '../../enterprisedevops/framework';

type Props = { runs?: PipelineRunRow[] };

export function CICDPipelinesPanel({ runs = [] }: Props) {
  return (
    <div className="space-y-2">
      {runs.map((r) => (
        <div key={r.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{r.name}</p>
            <p className="text-xs text-slate-500">{r.stage}</p>
          </div>
          <div className="text-right">
            <p className="text-xs text-slate-500">{r.duration}</p>
            <span className={cn(
              'text-xs font-medium',
              r.status === 'passed' ? 'text-success-600' :
              r.status === 'pending' ? 'text-warning-600' :
              r.status === 'armed' ? 'text-brand-600' : 'text-error-600',
            )}>
              {r.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
